import { Box, CircularProgress } from '@mui/material'

export function Loading({ ...props }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
      <CircularProgress {...props} />
    </Box>
  )
}
